module.exports = __webpack_public_path__ + "static/media/eligible.48951fb1.png";